import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import oswaldFont from '../fonts/Oswald';
import poppinsFont from '../fonts/Poppins';
import nunitoFont from '../fonts/Nunito';
import colors from '../colors';

const GlobalStyle = createGlobalStyle`
  ${reset}

  ${oswaldFont}
  ${poppinsFont}
  ${nunitoFont}

  html {
    color: ${colors.white};
    font-family: Poppins, sans-serif;
    font-size: 11px;
    font-weight: 300;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  body {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }

  #root {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  div, input, section {
    box-sizing: border-box;
  }

  button {
    background-color: transparent;
    border: none;
    color: inherit;
    display: block;
    padding: 0;
    font-family: Poppins, sans-serif;
    font-size: 11px;
  }

  .js-focus-visible :focus:not(.focus-visible) {
    outline: 0;
  }

  .rrt-title {
    line-height: 1.3;
  }
`;

export default GlobalStyle;
